function o(){}export{o as noop};
